import { defineStore } from 'pinia';

export type OnboardingConfigType = {
    storageKey: string;
    title: string;
    successMessage: string;
    nextStepMessage: string;
    actionLabel?: string;
    showAction?: boolean;
    onAction?: () => void;
};

type OnboardingStoreState = {
    isOpen: boolean;
    currentConfig: OnboardingConfigType | null;
};

export const useOnboardingStore = defineStore('onboarding', {
    state: (): OnboardingStoreState => ({
        isOpen: false,
        currentConfig: null,
    }),

    actions: {
        shouldShow(storageKey: string): boolean {
            return localStorage.getItem(storageKey) !== 'true';
        },

        show(config: OnboardingConfigType): void {
            if (!this.shouldShow(config.storageKey)) {
                return;
            }

            this.currentConfig = config;
            this.isOpen = true;
        },

        close(): void {
            if (this.currentConfig) {
                localStorage.setItem(this.currentConfig.storageKey, 'true');
            }
            this.isOpen = false;
            this.currentConfig = null;
        },

        handleAction(): void {
            if (this.currentConfig?.onAction) {
                this.currentConfig.onAction();
            }
            this.close();
        },

        reset(storageKey: string): void {
            localStorage.removeItem(storageKey);
        },
    },
});
